import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthApi } from "@/api/api";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import AdminNavbar from "@/pages/admin/AdminNavbar.tsx";

const AdminProtectedRoute = () => {
    // null: Đang kiểm tra, true: Đã đăng nhập, false: Chưa đăng nhập
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
    const location = useLocation();

    useEffect(() => {
        const verifyAuth = async () => {
            try {
                // Gọi API lấy thông tin.
                // Trình duyệt sẽ tự đính kèm Cookie. Nếu Cookie hợp lệ -> Thành công.
                await AuthApi.getInfo();
                setIsAuthenticated(true);
            } catch (error) {
                // Nếu lỗi 401 (chưa đăng nhập hoặc token hết hạn)
                setIsAuthenticated(false);
                toast.error("Bạn chưa đăng nhập hoặc phiên làm việc đã hết hạn.");
            }
        };

        verifyAuth();
    }, [location.pathname]); // Chạy lại kiểm tra mỗi khi chuyển trang bên trong admin

    // Hiển thị màn hình chờ trong lúc gọi API kiểm tra
    if (isAuthenticated === null) {
        return (
            <div className="min-h-screen flex flex-col items-center justify-center bg-background">
                <Loader2 className="animate-spin text-primary mb-4" size={40} />
                <p className="text-muted-foreground">Đang xác thực quyền truy cập...</p>
            </div>
        );
    }

    // Nếu chưa đăng nhập -> Điều hướng thẳng về trang đăng nhập
    if (!isAuthenticated) {
        return <Navigate to="/admin/login" replace />;
    }

    // Nếu đã đăng nhập -> Cho phép đi tiếp vào các component con (Outlet)
    return (
        <div className="min-h-screen flex flex-col bg-muted/20">
            {/* Navbar sẽ luôn xuất hiện ở trên cùng */}
            <AdminNavbar />

            {/* Vùng chứa nội dung của từng trang quản lý (Product, Order, Email...) */}
            <main className="flex-1 w-full">
                <Outlet />
            </main>
        </div>
    );
};

export default AdminProtectedRoute;